import { Translate } from '../../../shared/LanguageService';
import { FirmsKeepingOwnAgreement } from '../../customerAgreements/types';

function firmList(firmsKeepingOwnAgreement: FirmsKeepingOwnAgreement): string {
    const names = firmsKeepingOwnAgreement.firms.join(', ');

    if (firmsKeepingOwnAgreement.remainingFirmCount === 0) {
        return names;
    }

    return `${names} ${Translate('customer-agreements/form/error/in-use-remaining-customers', {
        count: firmsKeepingOwnAgreement.remainingFirmCount
    })}`;
}

export function firmsKeepingOwnAgreementText(
    firmsKeepingOwnAgreement: FirmsKeepingOwnAgreement
): string {
    return Translate('brokers/customer-agreement/notification/firms-keep-own-agreement', {
        firms: firmList(firmsKeepingOwnAgreement)
    });
}
